import {
    BUNDLE_NETPRICE_POST_REQUEST,
    BUNDLE_NETPRICE_POST_ERROR,
} from '../actionTypes/BundleNetPriceActionTypes';

const bundleNetPrice = (payload) => ({
    type: BUNDLE_NETPRICE_POST_REQUEST,
    payload,
});

export const resetBundleNetPrice = (payload) => ({
    type: BUNDLE_NETPRICE_POST_ERROR,
    payload,
});

export default bundleNetPrice;
